<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableWebApplicationFirewall",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountIds: [],
      columns: [
        {
          title: this.$t("RAM.ALI.Waf.accountName"),
          key: "accountName",
        },
        {
          title: this.$t("RAM.ALI.Waf.accountID"),
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.ALI.Waf.region"),
          key: "region",
        },
        {
          title: this.$t("RAM.ALI.Waf.instanceId"),
          key: "instanceId"
        },
        {
          title: this.$t("RAM.ALI.Waf.statusName"),
          key: "statusName"
        },
        {
          title: this.$t("RAM.ALI.Waf.versionName"),
          key: "versionName"
        },
      ],
      tableData: [],
    };
  },
  beforeCreate: function () {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function (val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountName", function (val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("instanceId",function (val) {
      tableDataVue.instanceId = val;
    })
  },
  mounted: function () {
    // tableDataVue.getData();
  },
  methods: {
    showAll: function () {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function () {
      // 获取搜索内容
      eventBus.$on("companyId", function (val) {
        tableDataVue.companyId = val;
      });
      eventBus.$on("accountName", function (val) {
        tableDataVue.accountName = val;
      });
      eventBus.$on("instanceId",function (val) {
        tableDataVue.instanceId = val;
      })
      this.$api.resourceManagement
        .selectALiWafByPage({
          accountName: tableDataVue.accountName,
          companyId: tableDataVue.companyId,
          instanceId:tableDataVue.instanceId,
          pageNum: this.current,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function (current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function (pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/waf/TableWebApplicationFirewall.vue